import { defineMessages } from 'react-intl';

export default defineMessages({
    constructionHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Construction",
        defaultMessage: "Construction"
    },
    yearBuilt: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Year Built",
        defaultMessage: "Year Built"
    },
    constructionStartDate: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Construction Start Date",
        defaultMessage: "Construction Start Date"
    },
    constructionType: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Construction Type",
        defaultMessage: "Construction Type"
    },
    numberOfStories: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Number Of Stories",
        defaultMessage: "Number Of Stories"
    },
    totalArea: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Total Area",
        defaultMessage: "Total Area"
    },
    roofType: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Roof Type",
        defaultMessage: "Roof Type"
    },
    editConstructionDetails: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction.Edit Construction Details",
        defaultMessage: "Edit Construction Details"
    }
})